import { Component } from '@angular/core'

@Component({
  selector: 'flo-offered-devices',
  templateUrl: './offered-devices.component.html',
  styleUrls: ['./offered-devices.component.scss']
})
export class OfferedDevicesComponent {}
